export const forceChangeSliderPosition = () => {
    const body = document?.querySelector('body');
    const html = document.documentElement;

    setTimeout(() => {
        // force change slider position
        if(body !== null && html !== null) {
            body.style.overflow = 'visible';
            body.style.position = 'static';
            html.style.overflow = 'visible';
        }
    }, 400);
};
